<template lang="pug">
div
	page-header(:title='title', :url='url', :titleNew='titleNew')
	.row
		.col-md-3
			select-form(v-model='filtro.secretaria', :value='filtro.secretaria', name='Secretaria', :url='`/secretaria?ativo=1`', id='id', titulo='titulo' optionText="Todos")
		.col-md-4
			input-form-text(textInput='Título', :required='true', v-model='filtro.title', :value='filtro.title' :layout="false")
		.col-md-4
		.col-md-1
			br
			button.btn.btn-primary(@click.prevent='getLimparFiltro') Limpar
	br
	vue-element-loading(:active='isActive' spinner='bar-fade-scale' color='#428BCA')
	grid(
		ref="grid" 
		:url='urlDataSource'
		:columns='columns'
		:GridHeight="400"
		:GridPageable="true"
		:DSpageSize="8"
		:DSserverPaging="true"
		:DSschema="true"
		:DSschemaData="'data'"
		:DSschemaTotal="'total'"
		:DSschemaParse="parse"
		:GridPageablePageSizes="[1, 10, 20, 100]"
		:DSfilter="filter"
		:DSserverFiltering="true"
	)
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import PageHeader from '@/components/PageHeader'
import Grid from '@/components/Grid'

import GridTemplate from '@/mixins/GridTemplate'
import Permission from '@/mixins/Permission'
import TemplateCapa from './TemplateCapa'

import InputFormText from '@/components/form/InputForm'
import SelectForm from '@/components/form/SelectForm'

import { confirme, erro, sucesso } from '@/components/Message'
import req from '@/components/request'

import moment from 'moment'

export default {
	mixins: [GridTemplate, Permission],
	components: {
		VueElementLoading,
		PageHeader,
		Grid,
		InputFormText,
		SelectForm
	},
	computed: {
		filter() {
			return {
				logic: 'and',
				filters: [
					{
						field: 'secretaria',
						operator: 'contains',
						value: this.filtro.secretaria
					},
					{
						field: 'title',
						operator: 'contains',
						value: this.filtro.title
					}
				]
			}
		},
		urlDataSource() {
			return `${this.$url}/v1/noticias?destaque=8`
		}
	},
	watch: {
		'filtro.secretaria' () {
			this.setFiltro()
		},
		'filtro.title' () {
			this.setFiltro()
		}
	},
	data() {
		return {
			title: 'Notícias',
			titleNew: '',
			url: '/site/noticias/',
			columns: [{
				template: this.getTemplateCapa,
				title: 'Capa',
				width: 40,
			}, {
				field: 'not_data',
				title: 'Data',
				width: 80
			}, {
				field: 'not_titulo',
				title: 'Título',
				width: 200
			}, {
				field: 'secretaria_name',
				title: 'Secretaria',
				width: 200
			}, {
				field: 'active_nome',
				title: 'Ativo',
				width: 120
			}
			],
			filtro: {
				secretaria: null,
				title: null,
			},
			isActive: false,
		}
	},
	methods: {
		parse(d) {
			d.data.map(i => {
				i.not_data = moment(i.not_data).format('DD/MM/YYYY HH:mm:ss')
				return i
			})
			return d
		},
		verifPermissao() {
			this.titleNew = this.ACTION.c ? 'Novo' : ''
			if (this.ACTION.e || this.ACTION.d) {
				this.columns.push({
					field: 'ativo',
					title: 'Ações',
					width: 105,
					template: this.commandTemplate
				})
			}
		},
		getTemplateCapa(e) {
			return {
				template: TemplateCapa,
				templateArgs: {
					data: e
				}
			}
		},
		setFiltro() {
			let filtro = {
				secretaria: this.filtro.secretaria,
				title: this.filtro.title,
			}
			localStorage.setItem('_filtroNoticias', JSON.stringify(filtro))
		},
		getLimparFiltro() {
			let filtro = {
				secretaria: null,
				title: null,
			}
			localStorage.setItem('_filtroNoticias', JSON.stringify(filtro))
			this.filtro = filtro
		},
		async buttonClickApagar(item) {
			const result = await confirme(item.title,'Tem certeza que deseja remover esse registro? pois a exclusão é irreversível e não é possível voltar os dados')
			if(result.isConfirmed) {
				this.isActive = true
				await req(`/v1/noticias/${item.id}`, 'delete').catch(response => {
					'error: ' + response
					erro()
				})
				sucesso('Atualizado...')
				this.$refs.grid.$refs.datasource1.kendoDataSource.read()
			}
			this.isActive = false
		}
	},
	created() {
		this.verifPermissao()
		let filtro = localStorage.getItem('_filtroNoticias')
			? JSON.parse(localStorage.getItem('_filtroNoticias'))
			: null
		if (filtro) {
			this.filtro = filtro
		}
	}
}
</script>

<style lang="stylus" scoped>

</style>
